const puids = require('../../utils/puids');

/**
 *
 * @param {Player} player - объект плеера
 * @param {Object} options - объект, содержащий в себе конфигурацию для воспроизведения рекламы
 */
function YandexIntegrator(player, options) {
  this.player = player;
  this.adPlaying = false;
  this.config = options.yandexAdConfig || {};
  this._createContainers();
}

YandexIntegrator.prototype._createContainers = function() {
  this.containerEl = document.createElement('div');
  this.containerEl.classList.add('yandex-ad-container');

  this.slot = window.document.createElement('div');
  this.slot.setAttribute('id', 'yandex-ad-slot');
  this.slot.classList.add('yandex-ad-slot');

  this.videoSlot = window.document.createElement('video');
  this.videoSlot.muted = true;
  this.videoSlot.controls = true;
  this.videoSlot.setAttribute('id', 'yandex-ad-video-slot');
  this.videoSlot.setAttribute('playsinline', 'true');
  if (this.player.muted()) {
    this.videoSlot.muted = true;
    this.videoSlot.setAttribute('muted', 'muted');
  }
  this.videoSlot.classList.add('yandex-ad-video-slot');

  this.slot.appendChild(this.videoSlot);
  this.containerEl.appendChild(this.slot);
  this.player.el().insertBefore(this.containerEl, this.player.controlBar.el());
}

YandexIntegrator.prototype._showContainer = function() {
  this.containerEl.style.display = 'block';
}

YandexIntegrator.prototype._hideContainer = function() {
  this.containerEl.style.display = 'none';
}

YandexIntegrator.prototype.isAdPlaying = function() {
  return this.isAdPlaying;
}

YandexIntegrator.prototype.playAd = function(adData, callback) {
  if (!window.ya) {
    // Завершаем воспроизведение рекламы ошибкой
    const error = new Error('Yandex Video Ads SDK didn\'t load');
    this.player.trigger({ type: 'vast.adError', error: error });
    return callback && callback(error);
  }

  const adTypeSettings = this.config[adData.type] || [];
  const adConfig = adTypeSettings.find(cfg => cfg.name === adData.name);

  // Если конфига нет
  if (!adConfig) {
    // Завершаем воспроизведение рекламы ошибкой
    const error = new Error('No config for current ad');
    this.player.trigger({type: 'vast.adError', error: error});
    return callback && callback(error);
  }

  if (adConfig.type === 'adfox') {
    return this._playAdFox(adConfig, callback);
  }

  return this._playStandardAd(adConfig, callback);
}

YandexIntegrator.prototype._playAdFox = function(adConfig, callback) {
  const videoSlot = this.videoSlot;
  this.adUnit = {
    config: adConfig,
    paused: false,
    pauseAd: function() {
      videoSlot.pause();
      this.paused = true;
    },
    resumeAd: function() {
      videoSlot.play();
      this.paused = false;
    },
    isPaused: function() {
      return this.paused;
    },
    adDuration: function() {
      return videoSlot.duration;
    },
    adPosition: function() {
      return videoSlot.currentTime;
    }
  };
  this.isAdPlaying = true;
  this.player.el().classList.add('yandex-ad-playing');
  this.videoSlot.addEventListener(
    'loadedmetadata',
    () => this.player.trigger({type: 'vast.adStart'}),
    { once: true }
  );

  let yandexConfig = JSON.parse(JSON.stringify(adConfig.config));
  if (yandexConfig && yandexConfig.adFoxParameters && yandexConfig.adFoxParameters.params) {
    const puidsReplacements = puids.getReplacements(this.player, this.player.vast.curAd.puidsList);
    for (param in yandexConfig.adFoxParameters.params) {
      let placeholder = yandexConfig.adFoxParameters.params[param] || '';
      if (!placeholder || !placeholder.startsWith || !placeholder.startsWith('$')) {
        continue;
      }

      if (puidsReplacements[placeholder] !== undefined && puidsReplacements[placeholder] !== null) {
        yandexConfig.adFoxParameters.params[param] = puidsReplacements[placeholder];
      }
    }
  }

  ya.videoAd.play({
    videoSlot: this.videoSlot,
    slot: this.slot,
    config: yandexConfig,
  }).then(() => {
    this._finishPlayAd(callback);
  }).catch((error) => {
    this._processError(error);
    callback && callback(error);
  });

  return this.adUnit;
}

YandexIntegrator.prototype._playStandardAd = function(adConfig, callback) {
  const videoSlot = this.videoSlot;
  this.adUnit = {
    config: adConfig,
    paused: false,
    pauseAd: function() {
      this.paused = true;
      this.adPlaybackController.pauseAd();
    },
    resumeAd: function() {
      this.paused = false;
      this.adPlaybackController.resumeAd();
    },
    isPaused: function() {
      return this.paused;
    },
    adDuration: function() {
      return this.adPlaybackController.getAdDuration();
    },
    adPosition: function() {
      return videoSlot.currentTime;
    }
  };

  const yandexConfig = adConfig.config;
  ya.videoAd.loadModule('AdLoader').then((module) => {
    if (!yandexConfig) {
      throw "No config for current ad";
    }

    return module.AdLoader.create(yandexConfig);
  }).then((adLoader) => {
    return adLoader.loadAd();
  }).then((adStore) => {
    return adStore.preload({
      videoSlot: this.videoSlot,
      desiredBitrate: 1000,
    }).then(() => {
      return adStore;
    }).catch(() => {
      return adStore;
    });
  }).then((adStore) => {
    // Создаем контроллер воспроизведения
    this.adUnit.adPlaybackController = adStore.createPlaybackController(this.videoSlot, this.slot);
    // Подписываемся на события рекламы
    this.adUnit.adPlaybackController.subscribe('AdStarted', () => this.player.trigger({type: 'vast.adStart'}));
    this.adUnit.adPlaybackController.subscribe('AdStopped', () => this._finishPlayAd(callback));
    this.adUnit.adPlaybackController.subscribe('AdPodError', (error) => this.player.trigger({type: 'vast.adError', error: error}));
    this._startPlayAd();
  }).catch((error) => {
    this._processError(error);
    callback && callback(error);
  });

  return this.adUnit;
}

YandexIntegrator.prototype._startPlayAd = function() {
  this.isAdPlaying = true;
  this._showContainer();
  this.player.el().classList.add('yandex-ad-playing');
  this.adUnit.adPlaybackController.playAd();
}

YandexIntegrator.prototype._finishPlayAd = function(callback) {
  this._reset();
  callback && callback();
}

YandexIntegrator.prototype._reset = function() {
  this.isAdPlaying = false;
  this._hideContainer();
  this.player.el().classList.remove('yandex-ad-playing');
  this.adUnit = null;
}

YandexIntegrator.prototype._processError = function(error) {
  this._reset();
  this.player.trigger({type: 'vast.adError', error: error});
}

module.exports = YandexIntegrator;
